const colors = [
  "var(--tw-red-500)",
  "var(--tw-orange-500)",
  "var(--tw-amber-500)",
  "var(--tw-yellow-500)",
  "var(--tw-lime-500)",
  "var(--tw-green-500)",
  "var(--tw-emerald-500)",
  "var(--tw-teal-500)",
  "var(--tw-cyan-500)",
  "var(--tw-sky-500)",
  "var(--tw-blue-500)",
  "var(--tw-indigo-500)",
  "var(--tw-violet-500)",
  "var(--tw-purple-500)",
  "var(--tw-fuchsia-500)",
  "var(--tw-pink-500)",
  "var(--tw-rose-500)",
];

function getColor(value: string) {
  const charCodeSum = value.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const index = charCodeSum % colors.length;
  return colors[index] ?? colors[0];
}

export { getColor };
